<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          v-for="(link, index) in items.slice(0, 2)"
          :key="index + 't'"
          lg="3"
          md="6"
          sm="12"
        >
          <template v-if="index === 0">
            <span style="font-size: 18px;">ฝั่งตลิ่งชัน</span>
          </template>
          <template v-else>
            <br>
          </template>
          <center>
            <VideoPlayer
              :source="link.RTSP_HLS"
              class="mt-2"
            />
            <span>  {{ link.ipaddress }}</span>
          </center>
        </b-col>
        <b-col
          v-for="(link, index) in items.slice(2, 4)"
          :key="index + 'k'"
          lg="3"
          md="6"
          sm="12"
        >
          <template v-if="index === 0">
            <span style="font-size: 18px;">ฝั่งบางกรวย</span>
          </template>
          <template v-else>
            <br>
          </template>
          <center>
            <VideoPlayer
              :source="link.RTSP_HLS"
              class="mt-2"
            />
            <span>{{ link.ipaddress }}</span>
          </center>
        </b-col>
      </b-row>
      <Flooding />
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import VideoPlayer from './VideoPlayer.vue'
import Flooding from '@/views/flooding/detail/Flooding.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    VideoPlayer,
    Flooding,
  },
  data() {
    return {
      items: [],
      Total: '',
      Online: '',
      Offline: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getFloodingCCTV()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getFloodingCCTV()
    }, 30000)
  },
  methods: {
    getFloodingCCTV() {
      axios
        .post('/camFlooding')
        .then(response => {
          this.items = response.data
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.vue2leaflet-map {
  &.leaflet-container {
    position: absolute;
    width: 1454px;
    height: 568px;
  }
}
</style>
